// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wR0K","field":"styles_field__3zu-o","fieldCol":"styles_fieldCol__1cQsb","diffCol":"styles_diffCol__3gSg7","diff":"styles_diff__gZqlq"};